import { IState } from '../../../store';
import { IUserTrackingData } from '../../../types';

export const selectTrackingUser = (state: IState): IUserTrackingData => state.tracking.user;
